export const ACCENT = '#0090d0';

const SEMANTIC = {
  success: { color: '#2a8a5a' },
  warning: { color: '#d08000' },
  danger:  { color: '#a02020' },
  info:    { color: '#0090d0' },
  neutral: { color: '#8aa0b8' },
};

export const C = {
  page:    { padding: '32px 36px', minHeight: '100%', fontFamily: "'Inter',sans-serif" },
  title:   { margin: 0, fontSize: 24, fontWeight: 800, color: '#1a2a3a', letterSpacing: '-.01em' },
  table:   { width: '100%', borderCollapse: 'collapse', background: 'rgba(255,255,255,0.75)', backdropFilter: 'blur(8px)', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 16px rgba(80,120,160,0.08)', border: '1px solid #dce8f0' },
  th:      { textAlign: 'left', padding: '12px 20px', fontSize: 11, fontWeight: 700, color: '#6a8aaa', textTransform: 'uppercase', letterSpacing: '.08em', background: 'rgba(220,232,240,0.5)', borderBottom: '1px solid #dce8f0' },
  tr:      { borderBottom: '1px solid #eef4f8', cursor: 'pointer', transition: 'background .1s' },
  td:      { padding: '14px 20px', fontSize: 13, color: '#1a2a3a', verticalAlign: 'middle' },
  btnPrimary: { background: 'linear-gradient(135deg, #0090d0, #0060a0)', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontWeight: 700, fontSize: 13, cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,120,200,0.2)' },
  btnSecondary: { background: 'transparent', border: '1px solid #c8d8e8', borderRadius: 7, padding: '6px 14px', fontSize: 12, fontWeight: 600, color: '#4a6a8a', cursor: 'pointer' },
  btnDanger: { background: 'transparent', border: '1px solid #f0c0c0', borderRadius: 7, padding: '6px 14px', fontSize: 12, fontWeight: 600, color: '#a02020', cursor: 'pointer', marginLeft: 6 },
  empty:   { padding: '48px 20px', textAlign: 'center', color: '#8aa0b8', fontSize: 14 },
  input:   { width: '100%', boxSizing: 'border-box', background: 'rgba(255,255,255,0.8)', border: '1px solid #c8d8e8', borderRadius: 8, padding: '9px 12px', color: '#1a2a3a', fontSize: 13, outline: 'none', fontFamily: "'Inter',sans-serif" },
  label:   { fontSize: 11, fontWeight: 600, color: '#6a8aaa', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 5, display: 'block' },
  modal:   { background: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(16px)', border: '1px solid #dce8f0', borderRadius: 14, padding: 28, width: 500, maxWidth: '95vw', maxHeight: '90vh', overflow: 'auto', boxShadow: '0 8px 40px rgba(80,120,160,0.15)' },

  // Status indicator: small colored dot + plain text. Caller renders:
  // <span style={C.statusRow(variant)}><span style={C.statusDot(variant)}/>{label}</span>
  statusRow: () => ({
    display: 'inline-flex', alignItems: 'center', gap: 6,
    fontSize: 12, fontWeight: 500, color: '#3a4a5a',
  }),
  statusDot: (variant) => {
    const s = SEMANTIC[variant] || SEMANTIC.neutral;
    return { width: 7, height: 7, borderRadius: '50%', background: s.color, flexShrink: 0 };
  },

  // Muted label for non-semantic categories (type, plan name, auth method…)
  mutedLabel: () => ({
    fontSize: 11, color: '#8aa0b8', fontWeight: 500,
  }),

  // Feedback strip (inline error / success / warning messages)
  feedback: (variant) => {
    const s = SEMANTIC[variant] || SEMANTIC.neutral;
    return {
      padding: '10px 14px', borderRadius: 8,
      fontSize: 13, color: s.color,
      background: s.color + '10',
      border: `1px solid ${s.color}40`,
      marginBottom: 14,
    };
  },

  // Keep pill/badge as lightweight aliases for components still using them
  pill: (variant) => {
    const s = SEMANTIC[variant] || SEMANTIC.neutral;
    return {
      display: 'inline-flex', alignItems: 'center', gap: 5,
      fontSize: 11, fontWeight: 500, color: s.color,
    };
  },
  badge: (variant) => {
    const s = SEMANTIC[variant] || SEMANTIC.neutral;
    return { fontSize: 11, color: s.color, fontWeight: 500 };
  },
};
